import { render, staticRenderFns } from "./BlockBlogListItemMeta.vue?vue&type=template&id=48c96818&scoped=true&"
import script from "./BlockBlogListItemMeta.vue?vue&type=script&lang=js&"
export * from "./BlockBlogListItemMeta.vue?vue&type=script&lang=js&"
import style0 from "./BlockBlogListItemMeta.vue?vue&type=style&index=0&id=48c96818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c96818",
  null
  
)

export default component.exports